import { render, staticRenderFns } from "./AddressCreateDialog.vue?vue&type=template&id=4bbf487b&scoped=true"
import script from "./AddressCreateDialog.vue?vue&type=script&lang=ts"
export * from "./AddressCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf487b",
  null
  
)

export default component.exports